<div class="footer">
  <div class="footer_content">
    <div>Powered By</div>
    <div><img src="../../../assets/images/ps-logo-2.png" /></div>
  </div>
  <div class="footer_address">
    <p>Unit D-3A-06, Menara Suezcap 1</p>
    <p>KL Gateway, No. 2 Jalan Kerinchi,</p>
    <p>Gerbang Kerinchi Lestari, 59200,</p>
    <p>Kuala Lumpur, Malaysia</p>
  </div>
  <div class="footer_content">
    <div class="contact">
      <img src="../../../assets/icons/whatsapp.png" />
      <span>+60111-684 2590</span>
    </div>
    <div class="contact">
      <img src="../../../assets/icons/email.png" />
      <span>customerservice&#64;policystreet.com</span>
    </div>
  </div>
</div>
<div class="copyright">
  Quotation and Policy issued by PolicyStreet (Polisea Sdn Bhd (Registration No:
  1212085-T)). Financial Adviser approved & licensed by Bank Negara Malaysia.
</div>
